/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppReleaseDto } from '../../models/app-release-dto';
import { PublishAppReleaseDto } from '../../models/publish-app-release-dto';

export interface AppReleaseControllerRollback$Params {
  id: string;

/**
 * 배포 워크플로우에서 사용하는 배포 전용 토큰
 */
  'x-deploy-token'?: string;
      body: PublishAppReleaseDto
}

export function appReleaseControllerRollback(http: HttpClient, rootUrl: string, params: AppReleaseControllerRollback$Params, context?: HttpContext): Observable<StrictHttpResponse<AppReleaseDto>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerRollback.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-deploy-token', params['x-deploy-token'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppReleaseDto>;
    })
  );
}

appReleaseControllerRollback.PATH = '/api/app-releases/{id}/rollback';
